import { useQuery } from "@tanstack/react-query";
import type {
  accountHierarchyAPIInterface,
  accountHierarchyFetchInterface
} from "@dealer-center/ddc-pages-account-hierarchy-interface";

const queryKeyBase = "ddc-pages-account-hierarchy";

export function useAccountHierarchyAPIInterface({
  name
}: accountHierarchyFetchInterface) {
  return useQuery({
    queryKey: [queryKeyBase, { name }],
    queryFn: () => getFunction(name?.trim() || ""),
    enabled: !!name && name.trim().length > 0,
    retry: 1,
    staleTime: 1000 * 60 * 5 // 5 minutes
  });
}

const getFunction = async (
  name: string
): Promise<accountHierarchyAPIInterface> => {
  const res = await fetch("/landing/nxlambda/accountHierarchy/" + name);
  if (res.ok) {
    return res.json();
  } else {
    throw new Error(res.statusText);
  }
};
